/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

export type AiProvider = 'Google' | 'OpenAI' | 'Anthropic' | 'DeepSeek';

export interface AiModel {
    id: string;
    name: string;
    provider: AiProvider;
    description: string;
    contextWindow: number;
    isPremium: boolean;
}

export const AVAILABLE_MODELS: AiModel[] = [
    {
        id: 'gemini-2.5-flash',
        name: 'Gemini 2.5 Flash',
        provider: 'Google',
        description: 'High-speed, low-latency model optimized for real-time market analysis.',
        contextWindow: 32000,
        isPremium: false
    },
    {
        id: 'gemini-3-pro-preview',
        name: 'Gemini 3.0 Pro',
        provider: 'Google',
        description: 'Advanced reasoning for complex strategy formulation and deep audits.',
        contextWindow: 128000,
        isPremium: true
    },
    {
        id: 'gpt-4o',
        name: 'GPT-4o',
        provider: 'OpenAI',
        description: 'Omni-model with state-of-the-art accuracy for code and financial sentiment.',
        contextWindow: 128000,
        isPremium: true
    },
    {
        id: 'claude-3-5-sonnet',
        name: 'Claude 3.5 Sonnet',
        provider: 'Anthropic',
        description: 'Exceptional coding and nuance capabilities. Best for contract auditing.',
        contextWindow: 200000,
        isPremium: true
    },
    {
        id: 'deepseek-v3',
        name: 'DeepSeek V3',
        provider: 'DeepSeek',
        description: 'High-performance open weights model specialized in math and logic.',
        contextWindow: 64000,
        isPremium: false
    }
];

export const DEFAULT_MODEL = AVAILABLE_MODELS[0].id;